/* global $, SGAction, SGEvent, ShopgatePriceHelper */

/*******************
 LibShopgate (Web)
 ********************/


/************************
 SGAction Implementation
 *************************/

/**
 * opens standard URL
 * @param options.src
 * @param options.noHistory (optional) if true use location.replace
 */
SGAction.openPage = function(options) {
	var defaults = {
		src: null,
		noHistory: false
	};

	options = options || {};
	options = $.extend({}, defaults, options);

	if (options.src) {
		if (!options.noHistory) {
			window.location.href = options.src;
		} else {
			window.location.replace(options.src);
		}
	}
};

/**
 * replaces the current top-of-stack page. replacePage is different from closing the top-of-stack followed by openPage in that the latter
 * would not work on a stack with a single view, because the last view cannot be removed from a stack.
 * @param options
 */
SGAction.replacePage = function(options) {
	(options && options.src) ? window.location.replace(options.src) : window.location.reload();
};

/**
 * opens standard URL in external tab
 */
SGAction.openPageExtern = function(options) {
	var defaults = {
		src: null
	};

	options = options || {};
	options = $.extend({}, defaults, options);

	if (options.src) {
		window.open(options.src, '_blank');
	}
};

/**
 * show the menu bar
 */
SGAction.showMenuBar = function() {
	// TODO: show Menu bar
};

/**
 * hide the menu bar
 */
SGAction.hideMenuBar = function() {
	// TODO: hide Menu bar
};

/**
 * shows an alert box with Button or several Buttons (depending on parameters)
 * @param options
 * @deprecated use showNotification
 */
SGAction.showAlert = function(options) {
	console.warn('deprecated use showNotification');
};


/**
 * shows an PopUp as an Notification
 * @param options
 */
SGAction.showNotification = function(options) {

	var defaults = {
		src: null,							// -> URL of WebView to be shown
		presentationType: 'centeredFade', 	// -> Enum which declares how the Notification is shown and hidden (centeredFade | pushTop | pushBottom | leftToRight | topToBottom)
		timeout: null, 						// (optional) -> in Seconds as a float
		speedFactor: 1, 					// (optional) -> by given tag, the animationSpeed can raised or reduced - Default is 1
		notificationParams: null, 			// (optional)(NON-Optional if needed by html) -> JSON-Object with params which are by Html content to display
		contentSrc: null	//TODO: add in wiki & implement in app				// (optional) HTML Content for the notification. no request needed if this is set
	};

	options = options || {};
	options = $.extend({}, defaults, options);

	// TODO: ajax request to options.src and show as PopUp

	if (!options.contentSrc && options.src) {
		$.ajax({
			url: options.src,
			type: 'GET'
		}).done(function(data) {
			// TODO: show data in popUp
		});
	} else if (options.contentSrc) {
		// TODO: show options.contentSrc in popUp
	} else {
		// no URL or content given
		console.warn('setBackgroundMenu() no URL or HTML content given');
		// TODO: log
	}
};


/**
 * shows an PopUp as an Notification
 * @param options
 */
SGAction.presentNotification = function(options) {

	var defaults = {
		src: null,							// -> URL of WebView to be shown
		presentationType: 'centeredFade', 	// -> Enum which declares how the Notification is shown and hidden (centeredFade | pushTop | pushBottom | leftToRight | topToBottom)
		timeout: null, 						// (optional) -> in Seconds as a float
		speedFactor: 1, 					// (optional) -> by given tag, the animationSpeed can raised or reduced - Default is 1
		notificationParams: null, 			// (optional)(NON-Optional if needed by html) -> JSON-Object with params which are by Html content to display
		content: null,	                    //TODO: add in wiki & implement in app				// (optional) HTML Content for the notification. no request needed if this is set
		baseUrl: null
	};

	options = options || {};
	options = $.extend({}, defaults, options);

	if (!options.content && options.src) {
		$.shopgate.ajax({
			url: options.src,
			type: 'GET'
		}).done(function(data) {
			// TODO: show data in popUp
		});
	} else if (options.content) {
		// TODO: show options.contentSrc in popUp
	} else {
		// no URL or content given
		console.warn('SGAction.presentNotification() no URL or HTML content given');
	}
};


/**
 * closes the current PopUp (for example notification)
 * @param animated (not used yet)
 */
SGAction.closeView = function(animated) {
	// TODO: close current PopUp
};

/**
 * Try to get geolocation data from browser
 * @param options
 */
SGAction.getLocation = function(options) {

	var positionOptions = {};

	if (!options.timeout || !$.isNumeric(options.timeout) || options.timeout > 60) {
		positionOptions.timeout = 60000;
	} else if (options.timeout < 1) {
		positionOptions.timeout = 1;
	} else {
		positionOptions.timeout = options.timeout * 1000;
	}

	if (navigator.geolocation) {
		navigator.geolocation.getCurrentPosition(setLocationSuccess, setLocationError, positionOptions);
	} else {
		setLocationError();
	}

	function setLocationSuccess(position) {
		SGEvent.Broadcast.setLocation({
			'latitude':		position.coords.latitude,
			'longitude':	position.coords.longitude,
			'accuracy':		position.coords.accuracy
		});
	}

	function setLocationError(error) {
		SGEvent.Broadcast.setLocation({});
	}
};

/***********************
 SGEvent Implementation
 ************************/

SGEvent.Broadcast.__dispatch = function(eventName, eventArguments) {

	if (SGEvent.callbacks.hasOwnProperty(eventName) && SGEvent.callbacks[eventName] instanceof Array) {
		SGEvent.callbacks[eventName].forEach(function(callback) {
			if (callback.executable) {
				callback.fn.apply(SGEvent, eventArguments);
			}
		});
	}
};

// replacement of the location object
window.sgWindow = {location: window.location};

$(document).ready(function() {

	SGEvent.Broadcast.viewDidAppear();
});

$(document).bind('shopgateFramework.dataUpdate.cart', function(e, data) {
	if (!data || !data.cart) {
		return;
	}

	// Update cart badge
	var badgeLabel = data.cart.productsCount > 0 ? data.cart.productsCount : '';
	$('#merchant-cart-button .badge').text(badgeLabel);

	// Update cart amount (on tablet)
	var priceHelper = new ShopgatePriceHelper();
	priceHelper.setDefaultsForCurrencyId(data.cart.amount.currency);

	var cartItemsAmount = shopSettings.priceDisplayMode == 'gross' ? data.cart.amount.products.gross : data.cart.amount.products.net;
	if (data.cart.coupons.length !== 0) {
		$.each(data.cart.coupons, function(i, e) {
			cartItemsAmount -= e.discountAmount;
		});
	}
	var cartItemsAmountFormatted = priceHelper.getAmountFormatted(cartItemsAmount * 100);

	$('.merchant-bar .cart-amount').html(cartItemsAmountFormatted);
});



// WEBPACK FOOTER //
// ./Library/1.0/web/LibShopgate_Web.js